<div id="container">
  <div class="ui bottom aligned grid">
    <div class="five wide column">
      @if (taxYearOptions) {
      <app-search-dropdown
        label="Select {{ yearLabel }}"
        [formGroup]="searchForm"
        [formCtrl]="taxYear"
        [listOptions]="taxYearOptions"
      ></app-search-dropdown>
      }
    </div>
    <div class="column">
      <div
        [routerLink]="['/settings', 'client-rules', 'builder']"
        [queryParams]="{ taxYear: taxYear?.value?.value }"
        class="ui primary background button"
        data-testid="client-rules-year-select-button"
      >
        {{ "settings.go" | transloco }}
      </div>
    </div>
  </div>
</div>
